import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import { Container, Typography, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';

const isAdmin = () => {
  // Example: store isAdmin as 'true' in localStorage after login
  return localStorage.getItem('isAdmin') === 'true';
};

const Landing: React.FC = () => {
  const [orderBatch, setOrderBatch] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const fetchOrderBatch = () => {
      axios.get('/orderbatch/current')
        .then(res => { if (isMounted) setOrderBatch(res.data); })
        .catch(() => { if (isMounted) setOrderBatch(null); })
        .finally(() => { if (isMounted) setLoading(false); });
    };

    fetchOrderBatch();
    const interval = setInterval(fetchOrderBatch, 60000);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, []);

  const admin = isAdmin();
  const isOpen = orderBatch?.isOpen;  

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Box textAlign="center">
        <Typography variant="h4" sx={{ fontWeight: 700, color: 'primary.main', mb: 2 }}>
          RVA Omas Orders
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          Welcome to the Richmond Raw Food Co-Op ordering system. {loading ? '' : isOpen ? 'Click below to start your order.' : ''}
        </Typography>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          {!loading && isOpen && (
            <Button
              component={Link}
              to="/order"
              variant="contained"
              size="large"
              sx={{ width: 260, py: 2, fontWeight: 700, fontSize: 20 }}
            >
              Go to Order Form
            </Button>
          )}
          {!loading && !isOpen && !admin && (
            <Typography color="error" sx={{ fontWeight: 600, fontSize: 18, mt: 2 }}>
              Ordering is currently closed
            </Typography>
          )}
          {admin && (
            <Button
              component={Link}
              to="/admin"
              variant="outlined"
              size="large"
              sx={{ width: 260, py: 2, fontWeight: 700, fontSize: 20 }}
            >
              Admin Menu
            </Button>
          )}
        </Box>
      </Box>
    </Container>
  );
};

export default Landing;
